package data.network.result

import kotlinx.serialization.Serializable

@Serializable
data class VideoResult<T>(
    val page: Int? = null,
    val result: T? = null,
    val totalPages: Int? = null,
    val totalResults: Int? = null,
)